import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createRemoveMemberUseCase({ membershipRepository }: Deps) {
  return async function removeMember(membershipId: string): Promise<void> {
    return membershipRepository.removeMember(membershipId);
  };
}
